import * as e from "react";
const c = ({
  title: l,
  titleId: a,
  ...t
}) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": a,
    ...t
  },
  l ? /* @__PURE__ */ e.createElement("title", { id: a }, l) : null,
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      d: "M3.159 12.996c-.543-.788-1.315-1.962-1.761-3.101a5.72 5.72 0 0 1 .977-5.816C3.61 2.631 5.343 2 6.92 2 9.192 2 11.145 3.262 12 5.196 12.855 3.262 14.808 2 17.08 2c1.577 0 3.31.63 4.545 2.08a5.72 5.72 0 0 1 .977 5.815c-.446 1.139-1.218 2.313-1.76 3.1C18.186 16.853 12 23 12 23s-6.186-6.148-8.841-10.004",
      clipRule: "evenodd"
    }
  )
);
export {
  c as default
};
